import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FieldAgentClient, Per, PriceChange, PriceChangeChangeType, ProcessPriceChangesRequset,
  ProcessPriceChangesRequsetTransactionType, ManualOrderLineType
} from 'ep-bt-field-agent-proxy';
import { EpLocalStorageService, IEpGridModel, EpEventService, EpButtonStyle, IEpPanelbarModel } from '@epicor/kinetic';
import { Router } from '@angular/router';
import { BistrackConfig, PageNames, Right } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpDataViewModelService, EpButtonSize } from '@epicor/kinetic';
import { ProductDetailModel } from '../../models/product-detail.model';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import {
  EpDialogService,
  IEpDialogResult
} from '@epicor/kinetic';
// import { ProductDetailsComponent } from 'ep-bt-field-agent';
import { CustomEvents } from 'ep-bt-controls';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-product-info',
  templateUrl: './epbt-fa-product-info.component.html',
  styleUrls: ['./epbt-fa-product-info.component.scss']
})
export class EpbtFaProductInfoComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;

  public gridModel: IEpGridModel;
  @Input() productId: number;
  branchId: number;
  productGroupId: number;
  productPricing: any;
  productGroups: any;
  @Input() selectedProductItem: any;
  currency: string;
  bistrackSettings: any;
  webTrackUser: any;
  productDetailModel: ProductDetailModel;
  buyPer: Per;
  lastCostPer: Per;
  productImageData: any;
  unAppliedChangeView: boolean;
  priceChanges: PriceChange[];
  lblPriceChange: number;
  EpButtonSize = EpButtonSize;
  pageNames = PageNames;
  manualOrderLineType: ManualOrderLineType;

  isProductAccessStandardBuyPrice = false;
  isProductAccessAverageCostWithAdditional = false;
  isProductAccessLastCost = false;

  @Input() isDetails = true;

  constructor(private client: FieldAgentClient, private router: Router, private faService: EpbtFieldAgentService,
    private config: BistrackConfig, private localStorageService: EpLocalStorageService,
    public epEvent: EpEventService, public productService: EpbtFaProductService,
    public quickOrderService: EpbtFaQuickOrderService) {
  }

  ngOnInit() {
    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      this.currency = this.bistrackSettings.baseCurrency.symbol;
    });
    if (this.productService.fromPage != this.pageNames.QuickOrderMOLTNegotiation) {
      this.faService.getWebTrackUser((webTrackUser: any) => {
        this.webTrackUser = webTrackUser;
        this.branchId = this.webTrackUser.webTrackTradingBranch.branchID;
        this.productId = this.selectedProductItem.productId;
        this.productGroupId = this.selectedProductItem.productGroupId;
        this.getInfoModelForProduct(this.selectedProductItem);
      });
    } else {
      this.manualOrderLineType = this.quickOrderService.quickOrderLine.ManualOrderLineType;
    }

    // Permissions...Start
    this.faService.checkDisplayPermissions(Right.ProductAccessStandardBuyPrice, (hasRight: boolean) => {
      this.isProductAccessStandardBuyPrice = hasRight;
    });
    this.faService.checkDisplayPermissions(Right.ProductAccessAverageCostWithAdditional, (hasRight: boolean) => {
      this.isProductAccessAverageCostWithAdditional = hasRight;
    });
    this.faService.checkDisplayPermissions(Right.ProductAccessLastCost, (hasRight: boolean) => {
      this.isProductAccessLastCost = hasRight;
    });
    // Permissions...end
  }

  getInfoModelForProduct(selectedProductItem: any) {

    // Get Pricing Details
    this.client.getProductPricing(this.productId, this.branchId).subscribe(res => {
      if (res != null && res.length > 0) {
        this.productPricing = res[0];
      }

      if (selectedProductItem.sellPer == null) {
        selectedProductItem.sellPer = new Per();
      }
      this.productDetailModel = new ProductDetailModel();
      this.productDetailModel.standardSellPrice = this.productPricing.standardSellPrice;
      this.productDetailModel.sellPerCode = this.productPricing.sellPer == '' ? (selectedProductItem.sellPer.perCode ? selectedProductItem.sellPer.perCode : '') : this.productPricing.sellPer;
      this.productDetailModel.averageCostWithAdd = this.productPricing.averageCostWithAdd;
      this.productDetailModel.averageCostPer = this.productPricing.averageCostPer == '' ?
        (selectedProductItem.sellPer.perCode ? selectedProductItem.sellPer.perCode : '') : this.productPricing.averageCostPer;
      this.productDetailModel.standardBuyPrice = this.productPricing.standardBuyPrice;

      // this patch to resolve issue when SP does not returning BuyPer
      this.buyPer = new Per();
      if (this.productPricing.buyPerId > 0) {
        if (this.productPricing.buyPerId == '') { this.productPricing.buyPer = this.buyPer.perCode; }
      }
      this.productDetailModel.buyPer = this.productPricing.buyPer == '' ? (selectedProductItem.sellPer.perCode ? selectedProductItem.sellPer.perCode : '') : this.productPricing.buyPer;
      this.productDetailModel.lastCost = this.productPricing.lastCost;

      // this patch to resolve issue when SP does not returning LastCostPer
      this.lastCostPer = new Per();
      if (this.productPricing.lastCostPerId > 0) {
        // Get Per2
        this.client.getPer2(this.productPricing.lastCostPerId).subscribe(res => {
          if (res != null) {
            this.lastCostPer = res;
          }
          if (this.productPricing.lastCostPer == '') { this.productPricing.lastCostPer = this.lastCostPer.perCode; }
        });
      }
      this.productDetailModel.lastCostPer = this.productPricing.lastCostPer == '' ? (selectedProductItem.sellPer.perCode ? selectedProductItem.sellPer.perCode : '') : this.productPricing.lastCostPer;

      // Get Product Group
      if (selectedProductItem.productGroupId != 0) {
        this.client.getProductGroup(this.productGroupId).subscribe(res => {
          if (res != null && res.length > 0) {
            this.productGroups = res[0];
          }

          // if (this.productGroups == null) {
          //   this.productDetailModel.productGroupName = "";
          // }
          // else {
          //   if (this.productGroups.name)
          //     this.productDetailModel.productGroupName = '';
          //   else
          //     this.productDetailModel.productGroupName = this.productGroups.name;
          // }

          this.productDetailModel.productGroupName = this.productGroups == null ? '' : this.productGroups.name;
        });
      }


      // Product Image
      if (selectedProductItem.productHasImage) {
        this.client.getProductImageData(this.productId).subscribe(resByteData => {
          if (resByteData != null) {
            this.productImageData = 'data:image/jpeg;base64,' + resByteData;
          }
        });
      }
      this.unAppliedChangeView = false;
      if (this.webTrackUser.allowApplyPriceChanges) {
        // Bind Product price change here
        this.client.getSellingPriceChanges(this.productId, this.branchId).subscribe(resPriceChanges => {
          if (resPriceChanges != null) {
            this.priceChanges = [];
            this.priceChanges = resPriceChanges;
          }
          if (this.priceChanges.length > 0) {
            this.unAppliedChangeView = true;
            // save changes in Session
            this.selectedProductItem.sellPriceChanges = this.priceChanges;
            this.productService.selectedProductItem = this.selectedProductItem;
            this.lblPriceChange = this.calculateProductPrice(this.selectedProductItem, this.priceChanges);
          }
        });
      }
    });
  }


  private calculateProductPrice(product: any, priceChanges: PriceChange[]): number {
    let result: number;
    result = product.standardSellPrice;
    priceChanges.forEach(change => {
      switch (change.changeType) {
        case PriceChangeChangeType.NewPrice:
          result = change.amount;
          break;
        case PriceChangeChangeType.Amount:
          result = result += change.amount;
          break;
        case PriceChangeChangeType.Percent:
          result *= (1 + (change.amount / 100));
          break;
        default:
          break;
      }
    });
    return result;
  }

  applyButtonClick() {
    let product = this.selectedProductItem;
    const processPriceChangesRequset = new ProcessPriceChangesRequset();
    processPriceChangesRequset.transactionType = ProcessPriceChangesRequsetTransactionType.Selling;
    processPriceChangesRequset.priceChanges = [];
    if (product.sellPriceChanges != null) {
      processPriceChangesRequset.priceChanges = product.sellPriceChanges;
    } else {
      processPriceChangesRequset.priceChanges = null;
    }
    processPriceChangesRequset.branchID = this.branchId;
    processPriceChangesRequset.userID = this.webTrackUser.bisTrackUserId;

    this.client.processPriceChanges(processPriceChangesRequset).subscribe(result => {
      if (result != null) {
        this.client.getProduct(product.productId).subscribe(res => {
          if (res != null) { product = res; }
          this.client.getProductPricing(this.productId, this.branchId).subscribe(res => {
            if (res != null && res.length > 0) {
              this.productPricing = res[0];
              // get proper pricing info here
              product.standardSellPrice = this.productPricing.standardSellPrice;

              // update product in session, otherwise user will be looking at old price...
              this.selectedProductItem = product;
              this.productService.selectedProductItem = this.selectedProductItem;

              // Prepare for redirect to Labels:
              this.selectedProductItem = product;
              this.productService.selectedProductItem = this.selectedProductItem;
              this.router.navigate(['/home/product/details'], this.selectedProductItem);
            } else {
              // Error message
              alert('Warning: Price was not changed. Please refer to BisTrack Cloud application log');
            }
          });
        });
      }
    });
  }


  moreproductDetails() {
    this.epEvent.broadcast(CustomEvents.NewQuickorderProductDetails);
  }


}
